import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(20),
    fontWeight: 400,
  },
  regenerateButton: {
    marginTop: pxToRem(20),
    paddingLeft: `${pxToRem(0)} !important`,
  },
});
